import { useLocation } from 'react-router-dom';
import CheckboxInput from '../../../components/inputs/CheckboxInput'
import { STATUS_IDS, USER_ROLES_IDS } from '../../../constants/common'
import useAuthStore from '../../../store/Auth'
import { Dispatch, SetStateAction, useMemo } from 'react';
import { APP_ROUTES } from '../../../routes';
import { useTranslation } from 'react-i18next';

interface AcknowledgementProps {
    isLossDeclaration: boolean;
    setIsLossDeclaration: Dispatch<SetStateAction<boolean>>
    isPermitApprovedByNextApprover: boolean;
    isFieldsDisabled: boolean;
    lostVehicleStickerIDCard?: {
        n_ApprovalStatus: number;
    }
}

const Acknowledgement = ({
    isLossDeclaration,
    setIsLossDeclaration,
    isPermitApprovedByNextApprover,
    isFieldsDisabled,
    lostVehicleStickerIDCard
}: AcknowledgementProps) => {
    const { t } = useTranslation();

    const location = useLocation();

    const { user } = useAuthStore()

    const searchParams = new URLSearchParams(location.search);

    const key = searchParams.get("ID");

    const isApprovePermitPage = useMemo(
        () => location.pathname === APP_ROUTES.APPROVE_LOST_VEHICLE_STICKER_ID_CARD,
        [location.pathname]
    );

    return (
        <>
            {user?.n_RoleID === USER_ROLES_IDS.STAFF &&
                (key && isApprovePermitPage ? (
                    <></>
                ) : (
                    <div className="flex flex-col gap-3 bg-white p-4 rounded-xl shadow-[0px_1px_5px_0px_rgba(113,112,163,0.3)]">
                        <CheckboxInput
                            id="lossDeclarationStatement"
                            label={t("lossDeclarationStatement")}
                            labelStyles="leading-[1.2]"
                            checked={
                                isLossDeclaration ||
                                isPermitApprovedByNextApprover ||
                                (user?.n_RoleID === USER_ROLES_IDS.STAFF &&
                                    isFieldsDisabled)
                            }
                            setChecked={setIsLossDeclaration}
                            readOnly={
                                (lostVehicleStickerIDCard &&
                                    lostVehicleStickerIDCard.n_ApprovalStatus !== STATUS_IDS.PENDING) ||
                                isPermitApprovedByNextApprover ||
                                (user?.n_RoleID === USER_ROLES_IDS.STAFF &&
                                    isFieldsDisabled)
                            }
                        />
                    </div>
                ))}
        </>
    )
}

export default Acknowledgement
